<div class="condition-edit">
    <div class="editor-field-row">
        <div
            translate
            [translateParams]="{ condition: conditionText }"
        >TCS.TemplateEditor.Tf.Rules.Validate.ThisField</div>
    </div>
</div>
